// バリエーションパラメータのリダイレクト処理
(function () {
  "use strict";

  /**
   * URLからバリエーションIDを取得する
   * @returns {string|null} バリエーションID
   */
  function getVariantIdFromURL() {
    try {
      const searchParams = new URLSearchParams(window.location.search);
      const variantId = searchParams.get("variant");
      return variantId;
    } catch (e) {
      console.error("[GALLERY_DEBUG] URLパラメータ解析エラー:", e);
      return null;
    }
  }

  /**
   * バリエーションパラメータを除去した通常ページにリダイレクトする
   */
  function redirectToNonVariantUrl() {
    try {
      const variantId = getVariantIdFromURL();
      if (!variantId) {
        return;
      }

      console.log("[GALLERY_DEBUG] バリエーションパラメータを検出:", variantId);

      // 現在のURLからバリエーションパラメータを削除
      const currentUrl = new URL(window.location.href);
      currentUrl.searchParams.delete("variant");

      // その他のパラメータは維持
      const cleanUrl = currentUrl.toString();

      // 履歴に残さずにリダイレクト
      console.log("[GALLERY_DEBUG] リダイレクト先:", cleanUrl);
      window.location.replace(cleanUrl);
    } catch (e) {
      console.error("[GALLERY_DEBUG] リダイレクト処理エラー:", e);
    }
  }

  // できるだけ早く実行するためにすぐに関数を実行
  // これにより他のスクリプトや要素の読み込み前にリダイレクトが行われる
  redirectToNonVariantUrl();

  // バックアップとしてDOMContentLoadedイベントでも実行
  // 最初の実行がなんらかの理由で失敗した場合の保険
  document.addEventListener("DOMContentLoaded", function () {
    redirectToNonVariantUrl();
  });

  // さらに、readystatechangeイベントでもチェック
  document.addEventListener("readystatechange", function () {
    if (
      document.readyState === "interactive" ||
      document.readyState === "complete"
    ) {
      redirectToNonVariantUrl();
    }
  });
})();
